(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    // Met à jour « Size: XS » (et le nom de la couleur) dès qu'on clique.
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches || !input.matches('.joeve-variants .xo-field-toggle__input')) return;
    const container = input.closest('.joeve-variants');
    // Le thème renomme les boutons « {product_123}Couleur » : on retire le préfixe
    const name = input.name.replace(/^\{[^}]*\}/, '');
    const label = container && container.querySelector(
      '.joeve-variants__selected[data-joeve-option="' + CSS.escape(name) + '"]'
    );
    if (label) label.textContent = input.getAttribute('xo-label') || input.value;
  });

  // « +1 » : affiche les couleurs restantes.
  document.addEventListener('click', (event) => {
    const more = event.target.closest && event.target.closest('[data-joeve-more]');
    if (more) more.closest('.joeve-color').classList.add('is-open');
  });
  } catch(e) { console.error(e); }
})();

})();
